/**
 * Soft recovery for wedged Android WebView decoders (PLAYER-19): one src remount
 * per clip before treating MEDIA_ERR_DECODE / SRC_NOT_SUPPORTED as terminal.
 *
 * Only reloads media source — caller must resume via {@link playVideo} / play-epoch
 * guards (on-air, non-HLS). Keyed by src so a second error falls through to Sentry.
 */

const DECODE_REMOUNT_SRC_KEY = '__lucimarkDecodeRemountAttemptedForSrc'

/**
 * @returns true when a remount was started (caller should skip overlay/Sentry for this error
 * and resume play through the normal playVideo path).
 */
export function tryRemountVideoAfterDecodeError(el: HTMLVideoElement): boolean {
  const src = el.currentSrc || el.getAttribute('src') || ''
  if (!src) {
    return false
  }
  const store = el as unknown as Record<string, string | undefined>
  if (store[DECODE_REMOUNT_SRC_KEY] === src) {
    return false
  }
  store[DECODE_REMOUNT_SRC_KEY] = src
  try {
    el.removeAttribute('src')
    el.load()
    el.src = src
    el.load()
    return true
  }
  catch {
    return false
  }
}
